/** Use for the canonical USDC contract on each supported EVM chain. */
export const CHAIN_USDC_ADDRESSES = {
    ethereum: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    polygon: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    arbitrum: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    optimism: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
    base: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    avalanche: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    bsc: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
};
/** Use for the canonical wrapped-native token on each supported EVM chain. */
export const CHAIN_WETH_ADDRESSES = {
    ethereum: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    polygon: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    arbitrum: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    optimism: '0x4200000000000000000000000000000000000006',
    base: '0x4200000000000000000000000000000000000006',
    bsc: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
};
/** Use for approval scans and other helpers that need a small canonical token set per chain. */
export const COMMON_TOKENS = {
    ethereum: [
        { symbol: 'USDC', address: CHAIN_USDC_ADDRESSES.ethereum },
        { symbol: 'USDT', address: '0xdAC17F958D2ee523a2206206994597C13D831ec7' },
        { symbol: 'DAI', address: '0x6B175474E89094C44Da98b954EedeAC495271d0F' },
        { symbol: 'WETH', address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2' },
        { symbol: 'WBTC', address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599' },
        { symbol: 'LINK', address: '0x514910771AF9Ca656af840dff83E8264EcF986CA' },
    ],
    polygon: [
        { symbol: 'USDC', address: CHAIN_USDC_ADDRESSES.polygon },
        { symbol: 'USDT', address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F' },
        { symbol: 'WETH', address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619' },
        { symbol: 'WMATIC', address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270' },
    ],
    arbitrum: [
        { symbol: 'USDC', address: CHAIN_USDC_ADDRESSES.arbitrum },
        { symbol: 'USDT', address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9' },
        { symbol: 'WETH', address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1' },
    ],
    optimism: [
        { symbol: 'USDC', address: CHAIN_USDC_ADDRESSES.optimism },
        { symbol: 'USDT', address: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58' },
        { symbol: 'WETH', address: '0x4200000000000000000000000000000000000006' },
    ],
    base: [
        { symbol: 'USDC', address: CHAIN_USDC_ADDRESSES.base },
        { symbol: 'WETH', address: '0x4200000000000000000000000000000000000006' },
    ],
    avalanche: [
        { symbol: 'USDC', address: CHAIN_USDC_ADDRESSES.avalanche },
        { symbol: 'USDT', address: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7' },
        { symbol: 'WAVAX', address: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7' },
    ],
    bsc: [
        { symbol: 'USDT', address: '0x55d398326f99059fF775485246999027B3197955' },
        { symbol: 'USDC', address: CHAIN_USDC_ADDRESSES.bsc },
        { symbol: 'WBNB', address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c' },
    ],
};
